<template lang="pug">
  div.customSelect.e-tags
    textarea(
    @blur="addItemFromInputValue()"
    :class="hasError ? 'is-invalid customSelect__select' : 'customSelect__select'"
    :placeholder="placeholder"
    :name="`${name}-input`"
    @keyup.enter.stop.prevent="addItemFromInputValue()"
    @input="onInput()"
    :disabled="disabled"
    ref="element"
    )

    div.customSelect__tags-area.cuscroll
      e-perfect-scrollbar
        div.tags-wrapper
          div(
          v-for="id, index in model[name]"
          ).customSelect__tag {{id}}
            span(
            v-if="!disabled"
            @click="removeItem(id, index)"
            ).close.close--small
</template>

<script>
  export default {
    name: 'e-tags',
    data () {
      return {
        error: null,
        newValue: ''
      }
    },
    props: {
      disablePlaceholderOption: {
        type: Boolean,
        default: true
      },
      onChangeValidation: {
        type: Boolean,
        default: false
      },
      formValidator: null,
      model: {
        type: Object,
        required: true
      },
      tabView: {
        type: String,
        default: null
      },
      name: {
        type: String,
        default: null,
        required: true
      },
      validationRule: {
        type: String,
        default: 'string'
      },
      required: {
        type: Boolean,
        default: false
      },
      modalVariableName: {
        type: String,
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: 'Добавить'
      },
      tagDelimiters: {
        type: Array,
        default: () => [',', "\n"]
      }
    },
    computed: {
      hasError () {
        if (this.error) {
          return true
        }
        return false
      }
    },
    created () {
      if (this.formValidator) {
        this.formValidator.subscribeInput(this)
      }
    },
    destroyed () {
      if (this.formValidator) {
        this.formValidator.unsubscribeInput(this)
      }
    },
    methods: {
      getInputValue () {
        return this.getElement().value
      },
      clearInputValue () {
        this.getElement().value = ''
      },
      onInput () {
        this.addItemOnFindDelimiter(this.getInputValue())
      },
      addItemOnFindDelimiter (val) {
        if (!val) {
          return
        }
        for (let i = 0; i < this.tagDelimiters.length; i++) {
          let delim = this.tagDelimiters[i]
          if (val.indexOf(delim) > -1) {
            this.addItemFromInputValue()
            break
          }
        }
      },
      addItemFromInputValue () {
        this.addItem(this.getInputValue())
        this.clearInputValue()
      },
      addItem (item) {
        if (!item) {
          return
        }
        let vals = [item]
        // split by delimiters
        this.tagDelimiters.forEach(d => {
          let newV = []
          vals.forEach(v => {
            let splited = v.split(d)
            newV = [...newV, ...splited]
          })
          vals = newV
        })
        // insert if no duplicates
        vals.forEach(v => {
          const trimmed = v.toString().trim()
          if (trimmed && this.model[this.name].indexOf(trimmed) === -1) {
            this.model[this.name].push(trimmed)
          }
        })
        this.change()
      },
      removeItem (item, index) {
        this.model[this.name].splice(index, 1)
        this.change()
      },
      change () {
        this.$emit('change')
        if (this.onChangeValidation) {
          this.validate()
        }
      },
      getElement () {
        return this.$refs.element
      },
      validate () {
        let msg = ''

        if (!Array.isArray(this.model[this.name])) {
          this.model[this.name] = []
        }

        if (this.required) {
          if (this.model[this.name].length < 1) {
            msg += 'Заполните поле'
          }
        }

        if (!msg) {
          let doublePattern = /^(\d*((\.\d{0,}))?(\d))$/i
          let numberPattern = /^\d*$/i
          this.model[this.name].forEach(v => {
            if (this.validationRule === 'double' && !doublePattern.test(v)) {
              msg = 'Допустимы числа вида 0.000, а не ' + v
            } else if (this.validationRule === 'number' && !numberPattern.test(v)) {
              msg = 'Допустимы только целые числа, а не ' + v
            }
          })
        }

        return {
          error: msg,
          tabView: this.tabView,
          name: this.name,
          modalVariableName: this.modalVariableName,
          el: this.getElement()
        }
      }
    }
  }
</script>
